import { render, staticRenderFns } from "./BusinessNameChange.vue?vue&type=template&id=19e9ae20&scoped=true&"
import script from "./BusinessNameChange.vue?vue&type=script&lang=js&"
export * from "./BusinessNameChange.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameChange.vue?vue&type=style&index=0&id=19e9ae20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e9ae20",
  null
  
)

export default component.exports